import {AllowedUsersModel} from 'library/src/authentication/models/AllowedUsersModel';
import {IntlShape} from 'react-intl';
import * as yup from 'yup';
import {ConnectedStationType} from '../models/WeatherStationResponse';

export const getWeatherStationInitialValues = (
  providerType: ConnectedStationType,
  producer: AllowedUsersModel,
) => {
  switch (providerType) {
    case ConnectedStationType.SENCROP: {
      return {
        email: producer.credentials?.email || '',
      };
    }
    case ConnectedStationType.WEENAT: {
      return {
        email: producer.credentials?.email || '',
      };
    }
    // case ConnectedStationType.MF: {
    //   return {
    //     email: producer.credentials?.email || '',
    //   };
    // }
    default: {
      return {};
    }
  }
};

export const getWeatherStationValidationSchema = (
  providerType: ConnectedStationType,
  intl: IntlShape,
) => {
  switch (providerType) {
    case ConnectedStationType.SENCROP: {
      return yup.object({
        email: yup
          .string()
          .email(intl.messages['modifyUser.validation.emailFormat'] as string)
          .required(intl.messages['modifyUser.validation.email'] as string),
      });
    }
    case ConnectedStationType.WEENAT: {
      return yup.object({
        email: yup
          .string()
          .email(intl.messages['modifyUser.validation.emailFormat'] as string)
          .required(intl.messages['modifyUser.validation.email'] as string),
      });
    }
    // case ConnectedStationType.MF: {
    //   return yup.object({
    //     email: yup
    //       .string()
    //       .email(intl.messages['modifyUser.validation.emailFormat'] as string)
    //       .required(intl.messages['modifyUser.validation.email'] as string),
    //   });
    // }
    default: {
      return yup.object({});
    }
  }
};

const getWeatherCredentialsUtils = (
  producer: AllowedUsersModel,
  providerType: ConnectedStationType,
  intl: IntlShape,
) => {
  return {
    initialValue: getWeatherStationInitialValues(providerType, producer),
    validationSchema: getWeatherStationValidationSchema(providerType, intl),
  };
};

export default getWeatherCredentialsUtils;
